import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema, TraceIdSchema, CorrelationIdSchema } from "../primitives/ids.js";
/** audit-event.v1.0 — persisted audit / observability envelope */
export const AuditEventClassificationSchema = z.enum(["OPERATIONAL", "SECURITY"]);
export const AuditEventV1Schema = z
    .object({
    schemaVersion: z.literal("audit-event.v1.0"),
    eventType: z.string().min(1),
    owner: z.string().min(1),
    occurredAt: z.string().datetime(),
    traceId: TraceIdSchema,
    correlationId: CorrelationIdSchema.optional(),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema.optional(),
    payloadSummary: z.string().min(1).max(4000),
    classification: AuditEventClassificationSchema,
    /**
     * PF-005 additive documentation field only — not persisted.
     * AuditEvent rows are append-only at the DB layer (UPDATE/DELETE denied).
     */
    immutability: z.literal("append_only_db_enforced").optional(),
})
    .strict();
//# sourceMappingURL=audit-event.js.map